<template>
  <div class="user-container">
    <nav class="add-navigation">
      <div class="right-wrapprr"></div>
    </nav>
    <table class="table table-bordered table-striped table-responsive-md">
      <thead>
        <tr>
          <th>User</th>
          <th>Created On</th>
          <th>Password</th>
          <th>Status</th>
          <th></th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(user, k) in users"
          :class="{'active': user.status === 'active', 'inactive': user.status === 'inactive'}"
          :key="k"
        >
          <td style="min-width: 100px">
            <div class="status"></div>
            {{user.reseller_name}}
          </td>
          <td style="min-width: 120px">{{new Date(user.created_on).toDateString()}}</td>
          <td style="min-width: 120px">{{user.passwd}}</td>
          <td style="min-width: 70px">{{user.status}}</td>
          <td class="icon">
            <div
              class="radio-button"
              @click="changeStatus(user)"
              :class="user.status == 'active' ? 'active': ''"
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <title>Components / Field / Radio / Default</title>
                <desc>Created with Sketch.</desc>
                <defs />
                <g
                  id="Components-/-Field-/-Radio-/-Default"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    stroke="#BDBFD8"
                    fill="#FFFFFF"
                    x="0.5"
                    y="0.5"
                    width="23"
                    height="23"
                    rx="11.5"
                  />
                </g>
              </svg>
            </div>
          </td>
          <td>
            <button class="btn btn-primary btn-sm" @click="showAllowanceModal = true">Allowance</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :per-page="per_page"
        :total="TotalPages"
        :qnt="users.length"
      />
    </div>
    <Modal class="modal-size" v-if="showAllowanceModal" @close="showAllowanceModal = null">
      <h3 slot="header"></h3>
      <div slot="body">
        <form class="form">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="col-md-12 field-width">
                <table class="table table-bordered w-100 table-responsive-lg">
                  <thead>
                    <tr>
                      <th style="width:170px">Country</th>
                      <th style="width:150px">Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,key) in popUpData" :key="key">
                      <td style="min-width: 150px">
                        <div class="form-group" v-if="showRow == key">
                          <primary-select
                            type="text"
                            class="did"
                            v-model="editRow.country"
                            placeholder="Country"
                          >
                            <option value disabled hidden selected>Select Country</option>
                            <option :value="i" v-for="(i,k) in country" :key="k">{{i}}</option>
                          </primary-select>
                        </div>
                        <span v-if="showRow != key">{{item.country}}</span>
                      </td>
                      <td style="min-width: 150px">
                        <div class="form-group" v-if="showRow == key">
                          <primary-input
                            type="number"
                            class="field"
                            v-model="editRow.count"
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has('count')}"
                            placeholder="Count"
                          />
                          <div
                            class="help is-danger"
                            v-if="errors.has('count')"
                          >{{ errors.first('count') }}</div>
                        </div>
                        <span v-if="showRow != key">{{item.count}}</span>
                      </td>
                      <td style="min-width: 200px">
                        <button
                          class="btn btn-secondary btn-sm mr-2"
                          @click.prevent="showEditRow(item,key)"
                          v-if="showRow != key"
                        >Edit</button>
                        <button
                          class="btn btn-secondary btn-sm mr-2"
                          @click.prevent="editNewRow(key)"
                          v-if="showRow == key"
                        >Add</button>
                        <button
                          class="btn btn-danger btn-sm mr-2"
                          @click.prevent="deleteRow(key)"
                          v-if="showRow != key"
                        >Delete</button>
                        <button
                          class="btn btn-primary btn-sm"
                          @click.prevent="newRow = true"
                          v-if="showRow != key"
                        >+</button>
                      </td>
                    </tr>

                    <tr v-if="newRow">
                      <td>
                        <div class="form-group">
                          <primary-select
                            type="text"
                            class="did"
                            v-model="countryName"
                            placeholder="Country"
                          >
                            <option value disabled hidden selected>Select Country</option>
                            <option
                              :value="i"
                              v-for="(i,k) in country"
                              :key="k"
                              :disabled="countryName"
                            >{{i}}</option>
                          </primary-select>
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <primary-input
                            type="number"
                            class="field"
                            v-model="count"
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has('count')}"
                            placeholder="Count"
                          />
                          <div
                            class="help is-danger"
                            v-if="errors.has('count')"
                          >{{ errors.first('count') }}</div>
                        </div>
                      </td>
                      <td>
                        <button class="btn btn-secondary btn-sm mr-2" @click.prevent="addNew">Add</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div slot="footer" class="m-top-100">
        <!--                <button class="btn btn-primary submit customBtnStyle" @click="addPayment">Submit</button>-->
        <button @click="showAllowanceModal = null" class="btn btn-block cancel">Cancel</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { format } from "date-fns";
import axios from "axios";
export default {
  name: "UserListing",
  components: {
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    Modal: () => import("@/components/Modal.vue")
  },
  data() {
    return {
      users: [],
      count: null,
      country: ["US", "China", "Russia", "Italy", "Spain"],
      countryName: null,
      popUpData: [
        { country: "China", count: 100 },
        { country: "US", count: 200 }
      ],
      editRow: [{ country: "", count: "" }],
      showRow: null,
      newRow: false,
      Page: 0,
      TotalPages: null,
      pages: [10, 20, 50, 100, 200],
      per_page: 10,
      showAllowanceModal: null,
      api: "http://88.198.219.62/api_smsc/v1"
    };
  },
  created() {
    this.getUsersList();
  },
  methods: {
    getUsersList() {
      this.$store
        .dispatch("GetUsersListing", {
          page: this.Page,
          full_name: this.SearchUser
        })
        .then(res => {
          console.log("res--->", res);
          this.Page = res.page;
          this.TotalPages = res.total / res.per_page;
          this.users = res.items;
        });
      // axios.get(this.api+'/user/list',{
      //     headers: {
      //         "X-Auth-Token": 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE1OTM3MDU2MzQsInVzZXJfaWQiOjEyMn0.ZQstocXsiJu4M2U5vX7coJNImLtUaYkHf-I8aMbeQ94'
      //     }
      // }).then((res)=>{
      //     let data = res.data.payload
      //     this.users = data.items
      //     this.Page = data.page;
      //     this.TotalPages = data.total / data.per_page;
      //     console.log(this.users)
      // }).catch((err)=>{
      //     console.log(err)
      // })
    },
    changePage(page) {
      this.Page = page;
      this.getUsersList(this.SearchUser, this.Page);
    },
    changePerPage(e) {
      this.getUsersList();
    },
    addNew() {
      let obj = {
        country: this.countryName,
        count: this.count
      };
      this.popUpData = [...this.popUpData, obj];
      this.newRow = false;
    },
    deleteRow(index) {
      let data = [...this.popUpData];
      data.splice(index, 1);
      this.popUpData = data;
    },
    showEditRow(item, key) {
      this.showRow = key;
      this.editRow.country = item.country;
      this.editRow.count = item.count;
    },
    editNewRow(key) {
      let data = [...this.popUpData];
      data[key].country = this.editRow.country;
      data[key].count = this.editRow.count;
      this.popUpData = data;
      this.showRow = null;
    },
    changeStatus(user) {
      let status = user.status == "active" ? false : true;
      axios
        .patch(
          this.api + "/user/" + user.user_id,
          { is_active: status },
          {
            headers: {
              "X-Auth-Token":
                "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE1OTM3MDU2MzQsInVzZXJfaWQiOjEyMn0.ZQstocXsiJu4M2U5vX7coJNImLtUaYkHf-I8aMbeQ94"
            }
          }
        )
        .then(res => {
          this.getUsersList();
          this.$snotify.success("User status was changed.", {
            timeout: 6000
          });
        })
        .catch(err => {
          console.log(err);
        });
      // this.$store.dispatch('EditCompanyInfo', {
      //     companyInfo: { is_active: company.isActive ? false : true},
      //     id: company.companyId
      // }).then(res => {
      //     this.$snotify.success("Company status was changed.", {
      //         timeout: 6000
      //     });
      //     this.getAllCompanies();
      // })
    }
  }
};
</script>

<style lang="scss" scoped>
.user-container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .perPage {
    width: 120px;
    display: inline-block;
  }
  .custom-row {
    margin-right: 10px;
    margin-left: 20px;
  }
  .buttons-wrapper {
    justify-content: flex-end !important;
  }
  .user-container .add-navigation .right-wrapprr .search-input {
    width: 100% !important;
  }
  table thead tr {
    background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
  }
  .btn-primary {
    background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
    border-color: #51a3f3;
  }
  table thead tr th {
    color: white;
    padding-left: 10px;
  }
  @media (max-width: 891px) {
    .right-wrapprr {
      width: 100% !important;
    }
  }
  @media (max-width: 767px) {
    .add-navigation {
      display: block !important;
      height: auto !important;
    }
    .buttons-wrapper {
      justify-content: flex-start !important;
      margin-top: 15px;
    }
  }
  @media (max-width: 600px) {
    .right-wrapprr {
      display: block !important;
    }
    .buttons-wrapper {
      width: 100% !important;
    }
    .col-lg-6.col-md-7.col-xs-12 {
      margin-top: 15px;
    }
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .right-wrapprr {
      display: flex;
      align-items: center;
      width: fit-content;
      .search-input {
        height: 40px;
        background-color: #ffffff;
      }
      .selects-wrapper {
        display: flex;
        align-items: center;
        width: fit-content;
        .filter_by {
          height: 40px;
          width: 85px;
          color: #55616e;
          font-weight: normal;
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
          padding: 10px 0 10px 30px;
        }
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 110px;
      }
    }
  }
}

table tr th {
  padding: 12px 0;
  font-size: 14px;
  color: #212b36;
  font-family: "Helvetica Neue";
  line-height: 20px;
  font-weight: normal;
}

tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 12px 10px;
  text-align: left;
}
.radio-button {
  height: 30px;
  width: 50px;
  border-radius: 15px;
  background-color: #ffffff;
  border: 1px solid #a6b6be;
  margin-left: 10px;
  padding: 1px 23px 3px 3px;
  cursor: pointer;
  svg {
    height: 24px;
    width: 24px;
    // box-shadow: 2px 2px 7px 0 rgba(77,84,94,0.24);
  }
}
.radio-button.active {
  padding: 2px 3px 3px 23px;
  background-color: #24e2b8;
  border: 0;
}
.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-grid;
  margin: 0 10px 0 12px;
}
.active {
  td .status {
    background-color: #24e2b8;
  }
}
.inactive {
  background-color: #f0f1fa;
  td .status {
    background-color: #d2305b;
  }
}
.cancel {
  border: 1px solid #ccc;
}
</style>
<style>
.modal-size .modal-container {
  width: 40% !important;
}
@media (max-width: 1600px) {
  .modal-size .modal-container {
    width: 60% !important;
  }
}
@media (max-width: 900px) {
  .modal-size .modal-container {
    width: 79% !important;
  }
}
</style>